import { SearchItem } from '@yiluhub/yilu-amp-types';

import { extractAmpProductAttribute } from 'utils/ampUtils';

import { ProductType } from 'modules/eurail/utils/types';

export function splitByPassType(searchResults: SearchItem[]): {
  continuous: SearchItem[];
  flexi: SearchItem[];
} {
  const continuous: SearchItem[] = [];
  const flexi: SearchItem[] = [];

  for (const result of searchResults) {
    const productType = extractAmpProductAttribute(result, 'product_type') ?? undefined;
    if (productType && productType === ProductType.CONTINUOUS) {
      continuous.push(result);
    } else if (productType && productType === ProductType.FLEXI) {
      flexi.push(result);
    }
  }

  return {
    continuous: sortByNumberOfTravelDays(continuous),
    flexi: sortByNumberOfTravelDays(flexi),
  };
}

export function sortByNumberOfTravelDays(searchResults: SearchItem[]): SearchItem[] {
  return [...searchResults].sort((a, b) => {
    const daysA =
      (extractAmpProductAttribute(a, 'number_of_travel_days') as unknown as number) ?? 0;
    const daysB =
      (extractAmpProductAttribute(b, 'number_of_travel_days') as unknown as number) ?? 0;
    return daysA - daysB;
  });
}
